import { Button } from "components/Button/Button"
import { DefaultNavigationBar } from "components/NavigationBar/DefaultNavigationBar"
import { Paper } from "components/Paper/Paper"
import { FormattedMessage } from "react-intl"
import { useNavigate } from "react-router"

/** 404 error page */
export const NotFoundError = () => {
  const navigate = useNavigate()

  return (
    <div className="flex items-center justify-center">
      <DefaultNavigationBar />
      <Paper id="404-page" className="mt-40 w-full max-w-[600px]">
        <div className="mb-8">
          <h3 className="text-center text-h2">
            <FormattedMessage id="pageNotFound.title" />
          </h3>

          <img className="img-fluid mt-md-0 mt-4" src="/img/others/img-20.png" alt="page not found" />
        </div>

        <p className="text-center !text-body2/medium !text-gray-500">
          <FormattedMessage id="pageNotFound.description" />
        </p>

        <div className="w-full pt-4">
          <Button onClick={() => void navigate("/")}>
            <FormattedMessage id="forgotPassword.backToLogin" />
          </Button>
        </div>
      </Paper>
    </div>
  )
}
